import React from "react";
import { ArrowUpRight } from "lucide-react";
import { useI18n } from "@/i18n/I18nProvider";
import { useCta } from "@/context/SettingsContext";
import { Btn, Section } from "@/components/ui-kit/Kit";
import { Reveal } from "@/components/motion/Reveal";

export const PageCta = ({ variant = "both" }) => {
  const { t } = useI18n();
  const cta = useCta();
  return (
    <Section className="border-t border-navy/10 bg-slate-50/70 py-16 sm:py-20" data-testid="page-cta">
      <Reveal>
        <div className="flex flex-col items-start gap-6 lg:flex-row lg:items-center lg:justify-between">
          <div>
            <h2 className="font-display text-2xl font-semibold text-navy sm:text-3xl">
              {t("home.finalCta.title")}
            </h2>
            <p className="mt-3 max-w-xl text-sm text-slate-600">{t("common.appNote")}</p>
          </div>
          <div className="flex flex-wrap gap-3">
            {variant !== "vendor" && (
              <Btn href={cta.member_registration_url || "#"} external variant="solid" data-testid="pagecta-member">
                {t("cta.joinMember")} <ArrowUpRight className="h-4 w-4" />
              </Btn>
            )}
            {variant !== "member" && (
              <Btn href={cta.vendor_registration_url || "#"} external variant="outline" data-testid="pagecta-vendor">
                {t("cta.registerVendor")}
              </Btn>
            )}
          </div>
        </div>
      </Reveal>
    </Section>
  );
};
